import React from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { AutoFetchButton } from '@core/Components/AutoFetchButton'
import { getFollowMeProfileFollowAccountsPaged } from '@core/Areas/FollowMe/helpers/api'

export const useAccountFollowListData = (
  listType: 'following' | 'followers',
  profileId?: string
) => {
  const isFollowing = listType === 'following'
  const { data, isLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: isFollowing
        ? [...queryKeys.followMeAccountProfileFollowing, profileId]
        : [...queryKeys.followMeAccountProfileFollowers, profileId],

      queryFn: ({ pageParam }: { pageParam: string | null }) =>
        getFollowMeProfileFollowAccountsPaged({ pageParam, accountId: profileId, isFollowing }),
      initialPageParam: null,

      getNextPageParam: lastPage => {
        if (!lastPage || lastPage.length < 25) return undefined
        return lastPage[lastPage.length - 1]?.id ?? undefined
      },

      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
    })

  const isEmptyState = data?.pages[0].length === 0
  const isFinalPage = data && data.pages[data.pages.length - 1].length < 25

  return {
    data,
    isLoading,
    refetch,
    isEmptyState,
    isRefetching,
    LoadMoreButton: () =>
      isFinalPage || isEmptyState ? null : (
        <AutoFetchButton onClick={fetchNextPage} isFetching={isFetchingNextPage} />
      ),
  }
}
